<template>
  <div class="news_list_cup">
    <div class="news_banner">
      <img src="../../../../static/img/news/en-newsba.jpg" alt="" width="100%">
    </div>
    <div class="news_list_items">
      <div v-for="(itemNsL,index) in newsItemsList" :key="index" class="list_item">
        <el-row :gutter="20">
          <el-col :span="16">
            <div>
              <div class="news_text_title" @click="readNews(itemNsL.newsId)">{{itemNsL.title}}</div>
              <div class="news_text_tips">
                <span>{{itemNsL.time}}&nbsp;&nbsp;</span>
                <span>Source：{{itemNsL.resource}}</span>
              </div>
              <p class="news_text_content">{{itemNsL.content}}</p>
              <div class="news_text_more" @click="readNews(itemNsL.newsId)">
                <img src="../../../../static/img/news/enmore.jpg" alt="">
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div @click="readNews(itemNsL.newsId)" class="newslist_coin">
              <img :src="itemNsL.path" width="380" height="240" alt="">
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="news_page">
        <el-pagination :page-size="pageSize" layout="prev, pager, next" :total="totalPage" @current-change="turnPage" background class="pager_style">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { newsList } from '@/api/enFrontApi/news';
export default {
  name: 'newsList',
  data() {
    return {
      newsItemsList: [],
      pageSize: 5,
      pageNo: 1, //
      totalPage: 1,
      defaultPath: '../../../static/img/blank.jpg'
    };
  },
  created() {
    this.getListInfo();
  },
  methods: {
    getListInfo() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      newsList(params).then(res => {
        this.totalPage = parseInt(res.data.pageTotal);
        this.newsItemsList = [];
        res.data.list.forEach(item => {
          let tempListObj = {
            path: '',
            title: '',
            time: '',
            content: '',
            newsId: '',
            resource: 'IAIC'
          };
          if (item.picMain) tempListObj.path = item.picMain;
          else tempListObj.path = this.defaultPath;
          tempListObj.title = item.newsTitle;
          tempListObj.time = item.promTime;
          tempListObj.content = item.newsSmBody;
          tempListObj.newsId = item.newsId;
          this.newsItemsList.push(tempListObj);
        });
      });
    },
    readNews(newsId) {
      this.$router.push({
        name: 'iaic2019en/newsInfo',
        params: {
          newsId: newsId
        }
      });
    },
    turnPage(val) {
      this.pageNo = val;
      this.getListInfo();
    }
  }
};
</script>
<style lang="stylus" scoped>
.news_list_cup {
  width: 100%;
  background-color: #fff;
}

.news_list_items {
  width: 70%;
  margin: 0 auto;
  min-height: 600px;
  padding: 10px 20px;
  overflow: hidden;

  .list_item {
    margin-top: 10px;
    min-height: 200px;
    background-color: #F9F9F9;
    padding: 20px 10px 20px 20px;

    .news_text_title {
      font-size: 24px;
      font-weight: bold;
      color: #000;
      margin: 20px 0;
      cursor: pointer;
    }
    .news_text_title:hover {
      color: #006980;
    }

    .news_text_tips {
      margin: 15px 0;
      color: #909399;
    }

    .news_text_content {
      margin-bottom: 20px;
      font-size: 16px;
      color: #303133;
      height: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* 第10行显示 ... */
      -webkit-box-orient: vertical;
    }

    .news_text_more {
      cursor: pointer;
    }
  }

  .newslist_coin:hover {
    cursor: pointer;
  }

  .news_page {
    margin: 10px 10px 0 10px;
  }
}

img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/news/news.vue